import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=357c0a5d&scoped=true&"
var script = {}
import style0 from "./Wrapper.vue?vue&type=style&index=0&id=357c0a5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357c0a5d",
  null
  
)

export default component.exports